import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import Form from './Form';
import { MakeFields } from './validation/fields';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { schema } from './validation/schema';

const ProblemsGiftcard = ({ ...props }) => {
  const { mobile, motiveId, issueForm, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);
  const [validLength] = useState(7);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm={issueForm}
        mobile={mobile}
        title=""
        schema={schema}
        data={data}
        fields={MakeFields()}
        formName="ProblemsGiftcard"
        makeInitialState={makeInitialState}
        onState={onState}
        motiveId={motiveId}
        typeId={typeId}
        validLength={validLength}
        onValid={handleValid}
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            fields={MakeFields()}
          />
        }
      />
    </React.Fragment>
  );
};

ProblemsGiftcard.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueForm: PropTypes.bool,
  typeId: PropTypes.string,
};

export default ProblemsGiftcard;
